import classNames from 'classnames';
import buttonAppearanceClasses from './styles/buttonAppearance.module.scss';

type GetAppearanceClassesProps = {
	appearance: {
		primary?: boolean;
		link?: boolean;
		linkDark?: boolean;
		danger?: boolean;
		dangerLink?: boolean;
		linkLike?: boolean;
	};
	state: {
		active?: boolean;
		pressed?: boolean;
		disabled?: boolean;
		canHover?: boolean;
	};
};

export function getAppearanceClasses({
	appearance: { primary, link, linkDark, danger, dangerLink, linkLike },
	state: { active, pressed, canHover, disabled },
}: GetAppearanceClassesProps): string {
	if (linkLike) {
		return '';
	}

	if (primary) {
		return classNames(buttonAppearanceClasses.button_primary, {
			[buttonAppearanceClasses.button_primaryCanHover]: canHover,
			[buttonAppearanceClasses.button_primaryActive]: active,
			[buttonAppearanceClasses.button_primaryPressed]: pressed,
			[buttonAppearanceClasses.button_primaryDisabled]: disabled,
		});
	}

	if (link) {
		return classNames(buttonAppearanceClasses.button_link, {
			[buttonAppearanceClasses.button_linkCanHover]: canHover,
			[buttonAppearanceClasses.button_linkActive]: active,
			[buttonAppearanceClasses.button_linkPressed]: pressed,
			[buttonAppearanceClasses.button_linkDisabled]: disabled,
		});
	}

	if (linkDark) {
		return classNames(buttonAppearanceClasses.button_linkDark, {
			[buttonAppearanceClasses.button_linkDarkCanHover]: canHover,
			[buttonAppearanceClasses.button_linkDarkActive]: active,
			[buttonAppearanceClasses.button_linkDarkPressed]: pressed,
			[buttonAppearanceClasses.button_linkDarkDisabled]: disabled,
		});
	}

	if (danger) {
		return classNames(buttonAppearanceClasses.button_danger, {
			[buttonAppearanceClasses.button_dangerCanHover]: canHover,
			[buttonAppearanceClasses.button_dangerActive]: active,
			[buttonAppearanceClasses.button_dangerPressed]: pressed,
			[buttonAppearanceClasses.button_dangerDisabled]: disabled,
		});
	}

	if (dangerLink) {
		return classNames(buttonAppearanceClasses.button_dangerLink, {
			[buttonAppearanceClasses.button_dangerLinkCanHover]: canHover,
			[buttonAppearanceClasses.button_dangerLinkActive]: active,
			[buttonAppearanceClasses.button_dangerLinkPressed]: pressed,
			[buttonAppearanceClasses.button_dangerLinkDisabled]: disabled,
		});
	}

	return classNames(buttonAppearanceClasses.button_secondary, {
		[buttonAppearanceClasses.button_secondaryCanHover]: canHover,
		[buttonAppearanceClasses.button_secondaryActive]: active,
		[buttonAppearanceClasses.button_secondaryPressed]: pressed,
		[buttonAppearanceClasses.button_secondaryDisabled]: disabled,
	});
}
